import React from 'react';
import { Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { FormItem } from '../../../components/FormItem';
import { useListCompanies } from '@/hooks/v1/useListCompanies';
import { CompanySelect } from '@/components/ui/Inputs/CompanySelect';
import { usePersonalisedReportContext } from '../../../../context';

const { useFormInstance, useWatch } = Form;

export const Companies: React.FC = () => {
	const form = useFormInstance();
	const { organization_id, company_id } = usePersonalisedReportContext();

	const fieldName = ['basic_information', 'company_id'];

	const companyId = useWatch(fieldName, form);

	const { data: companies, isFetching } = useListCompanies({
		organization_id,
		company_id
	});

	function clearHierarchy(): void {
		form.setFieldValue(['basic_information', 'sector_id'], undefined);
		form.setFieldValue(['basic_information', 'workstation_id'], undefined);
	}

	function handleCompanySelect(id: string): void {
		form.setFieldValue(fieldName, id);
		clearHierarchy();
	}

	function handleClearCompany(): void {
		form.setFieldValue(fieldName, undefined);
		clearHierarchy();
	}

	return (
		<Col xs={24}>
			<FormItem
				fontSize="1rem"
				isRequired
				namePath={fieldName}
				title="Industrial site"
				errorMessage={I18n.get('Select a company')}
			>
				<CompanySelect
					size="large"
					disabled
					loading={isFetching}
					companies={companies}
					companyId={companyId ?? company_id}
					handleClearCompany={handleClearCompany}
					handleSelectCompany={handleCompanySelect}
				/>
			</FormItem>
		</Col>
	);
};
